import { render } from "./AddDivisionControl.vue?vue&type=template&id=1789cd9c"
import script from "./AddDivisionControl.vue?vue&type=script&lang=js"
export * from "./AddDivisionControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__